export const getItemsByLimit = (arr, limit) => arr.filter((_, i) => i < limit);
